import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/@shared/shared.module';
import { AuthGuard } from 'src/@shared/auth.guard';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { APIHandlerService } from 'src/@services/apihandler.service';
import { PendingRequestsInterceptor } from 'src/Interceptors/pending-requests.interceptor';
import { provideAngularEditorIcons } from 'src/@shared/angular-editor-icons.initializer';
import { AuthInterceptorService } from './auth-interceptor.service';

registerLocaleData(en);
@NgModule({
  declarations: [AppComponent, ErrorpageComponent],
  imports: [
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    BrowserModule,
    InfiniteScrollModule,
    AppRoutingModule,
  ],
  providers: [
    APIHandlerService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PendingRequestsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
    provideAngularEditorIcons(),
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(trace: Sentry.TraceService) {}
}
